// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { Button } from '../../../../atoms';
import { useThemeId } from '@tectonics/prs/merchant';
import { getRedirectBackUrl, useIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Empty } from '@tectonics/components';
import { translate } from '@tectonics/translate';

export function BackButton(): Node {
  const incomingPayment = useIncomingPayment();
  const redirectBackUrl = getRedirectBackUrl(incomingPayment);

  const themeId = useThemeId();

  if(!redirectBackUrl)
    return <Empty />;

  return (
    <ButtonRoot
      as="a"
      href={redirectBackUrl}
      size="lg"
      flat={true}
      type="primary"
      themeId={themeId}
      outline="transparent"
      data-test-id="back-button"
    >
      <ButtonContent />
    </ButtonRoot>
  );
}

const ButtonRoot = styled(Button)`
  font-weight: 400;
  border: none;
  text-transform: uppercase;
`;

const ButtonContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

function ButtonContent(): Node {
  return (
    <ButtonContentWrapper>
      <span>
        <ButtonMessage />
      </span>
    </ButtonContentWrapper>
  );
}

function ButtonMessage(): Node {
  return translate('navigation.back');
}
